import NamedDto from 'modules/base/dto/NamedDto';

class VizsgazoTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.pontszam = null;
		/** @type {number} */
		this.erdemjegy = null;
		/** @type {string} */
		this.azonosito = null;
		/** @type {string} */
		this.vezeteknev = null;
		/** @type {string} */
		this.keresztnev = null;
		/** @type {NamedDto} */
		this.vizsgaHelyeVizsgazo = null;
		/** @type {NamedDto} */
		this.vizsgaVizsgazo = null;
		this.lastLoginTimestamp = null;
		this.lockedOnlineExam = null;
		/** @type {Date} */
		this.bornDate = null;
		/** @type {string} */
		this.mothersName = null;
		/** @type {string} */
		this.name = null;
		/** @type {string} */
		this.email = null;
	}

	/**
	 * @typedef {Object} _VizsgazoTableDtoProps
	 * @property {number} pontszam
	 * @property {number} erdemjegy
	 * @property {string} azonosito
	 * @property {string} vezeteknev
	 * @property {string} keresztnev
	 * @property {NamedDto} vizsgaHelyeVizsgazo
	 * @property {NamedDto} vizsgaVizsgazo
	 * @property {Date} bornDate
	 * @property {string} mothersName
	 * @property {string} name
	 * @property {string} email
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _VizsgazoTableDtoProps} VizsgazoTableDtoProps
	 */
	/**
	 *
	 * @param {VizsgazoTableDtoProps} props
	 * @returns {VizsgazoTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.pontszam = props.pontszam;
		this.erdemjegy = props.erdemjegy;
		this.azonosito = props.azonosito;
		this.vezeteknev = props.vezeteknev;
		this.keresztnev = props.keresztnev;
		this.vizsgaHelyeVizsgazo = props.vizsgaHelyeVizsgazo !== null ? new NamedDto().setup(props.vizsgaHelyeVizsgazo) : null;
		this.vizsgaVizsgazo = props.vizsgaVizsgazo !== null ? new NamedDto().setup(props.vizsgaVizsgazo) : null;
		this.lastLoginTimestamp = props.lastLoginTimestamp;
		this.lockedOnlineExam = props.lockedOnlineExam;
		this.bornDate = props.bornDate !== null ? new Date(props.bornDate) : null;
		this.mothersName = props.mothersName;
		this.name = props.name;
		this.email = props.email;
		return this;
	}
}

export default VizsgazoTableDto;
